
import React, { useState, useEffect, useRef } from 'react';
import { Row, Col, Modal, Button, Label, ModalHeader, ModalBody, ModalFooter, Input } from 'reactstrap';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import EdgeToast from '../components/EdgeToast';
import BaseAPI from '../helpers/base-api';

const baseAPI = new BaseAPI();
const appVersion = import.meta.env.VITE_APP_VERSION;

// Validation schema
const SupportSchema = Yup.object().shape({
    subject: Yup.string().required('Subject is required'),
    content: Yup.string().required('Content is required'),
});

const Footer = () => {
    const [modal, setModal] = useState(false);
    const toggleModal = () => setModal(!modal);

    const [showToast, setShowToast] = useState(false);
    const [toastType, setToastType] = useState('success');
    const [toastTitle, setToastTitle] = useState('');
    const [toastContent, setToastContent] = useState('');
    const toggleToast = () => setShowToast(!showToast);
    const showMessageToast = (type, title, content) => {
        setToastType(type);
        setToastTitle(title);
        setToastContent(content);
        setShowToast(true);
        setTimeout(() => {
            setShowToast(false);
        }, 10000);
    };

    const currentYear = new Date().getFullYear();

    const handleSupport = async (values, { setSubmitting }) => {
        try {
            const methodResp = await baseAPI.post(`support/send-email`, values);
            showMessageToast('success', 'Support email', 'It sent email to support team successfully.');
            toggleModal();
        } catch (e) {
            showMessageToast(
                'danger',
                'Support email',
                e.message ? e.message : 'It is failed to send email support team.'
            );
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <React.Fragment>
            <footer className="footer">
                <div className="container-fluid">
                    <Row>
                        <Col md={6}>{currentYear} © EDGE Markets, Inc</Col>

                        <Col md={6}>
                            <div className="footer-links">
                                <a href="https://edgeboost.io" target="_blank" rel="noopener noreferrer">About</a>
                                <a href="#" onClick={(e) => { e.preventDefault(); toggleModal(); }}>Support</a>
                                <span>Version {appVersion || '1.0.0'}</span>
                            </div>
                        </Col>
                    </Row>
                </div>
            </footer>

            <Modal isOpen={modal} toggle={toggleModal} backdrop="static">
                <ModalHeader toggle={toggleModal}>Support</ModalHeader>
                <Formik
                    initialValues={{ subject: '', content: '' }}
                    validationSchema={SupportSchema}
                    onSubmit={handleSupport}
                >
                    {({ isSubmitting, errors, touched }) => (
                        <Form>
                            <ModalBody>
                                <Row>
                                    <Col md={12}>
                                        <div className="form-group">
                                            <Label for="subject">Subject*</Label>
                                            <Field
                                                as={Input}
                                                type="text"
                                                name="subject"
                                                id="subject"
                                                placeholder="Subject"
                                                className={errors.subject && touched.subject ? 'is-invalid' : ''}
                                            />
                                            <ErrorMessage name="subject" component="div" className="invalid-feedback" />
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={12}>
                                        <div className="form-group">
                                            <Label for="content">Content*</Label>
                                            <Field
                                                as={Input}
                                                type="textarea"
                                                name="content"
                                                id="content"
                                                placeholder="Input content"
                                                rows="8"
                                                className={errors.content && touched.content ? 'is-invalid' : ''}
                                            />
                                            <ErrorMessage name="content" component="div" className="invalid-feedback" />
                                        </div>
                                    </Col>
                                </Row>
                            </ModalBody>
                            <ModalFooter>
                                <Button color="primary" type="submit" disabled={isSubmitting}>
                                    Send
                                </Button>{' '}
                                <Button color="secondary" onClick={toggleModal}>
                                    Cancel
                                </Button>
                            </ModalFooter>
                        </Form>
                    )}
                </Formik>
            </Modal>
            <EdgeToast
                isOpen={showToast}
                toggle={toggleToast}
                type={toastType}
                title={toastTitle}
                content={toastContent}
            />
        </React.Fragment>
    );
};

export default Footer;
